import { type JSX } from "react";
import { ControllerRenderProps, FieldPath, FieldValues } from "react-hook-form";

import { FormControl, FormItem, FormLabel } from "@/components/ui/form";
import { RadioGroup, RadioGroupItem } from "@/components/ui/RadioGroup";
import { cn } from "@/utils/core/generalUtils";

type RadioGroupField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> = ClassName & {
  field: ControllerRenderProps<TFieldValues, TName>;
  options: { label: string; value: string }[];
  defaultValue: string;
};

const RadioGroupField = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>(
  props: RadioGroupField<TFieldValues, TName>,
): JSX.Element => {
  const { field, options } = props;

  return (
    <RadioGroup
      onValueChange={field.onChange}
      className={cn("flex space-x-4", props.className)}
      defaultValue={props.defaultValue}
      value={field.value}
    >
      {options.map((option, index) => (
        <FormItem className='flex items-center space-x-3 space-y-0' key={index}>
          <FormControl>
            <RadioGroupItem value={option.value} />
          </FormControl>
          <FormLabel className='font-normal'>{option.label}</FormLabel>
        </FormItem>
      ))}
    </RadioGroup>
  );
};

export default RadioGroupField;
